/**
 * State Filter for Notary of America
 * ====================================
 * CLIENT-SIDE filtering — works across all collections
 *
 * TAG SYSTEM:
 *   No tags          → shows for ALL states always (universal product)
 *   state-FL         → only shows for Florida
 *   state-FL,state-TX → only shows for Florida or Texas
 *   exclude-CA       → shows for all states EXCEPT California
 *   all-states       → always shows (explicit universal, useful with excludes)
 *   all-states + exclude-CA → shows everywhere except California
 */

(function() {
  'use strict';

  var STATE_KEY = 'noa_selected_state';

  var ALL_STATES = [
    { abbr: 'AL', name: 'Alabama' },
    { abbr: 'AK', name: 'Alaska' },
    { abbr: 'AZ', name: 'Arizona' },
    { abbr: 'AR', name: 'Arkansas' },
    { abbr: 'CA', name: 'California' },
    { abbr: 'CO', name: 'Colorado' },
    { abbr: 'CT', name: 'Connecticut' },
    { abbr: 'DE', name: 'Delaware' },
    { abbr: 'FL', name: 'Florida' },
    { abbr: 'GA', name: 'Georgia' },
    { abbr: 'HI', name: 'Hawaii' },
    { abbr: 'ID', name: 'Idaho' },
    { abbr: 'IL', name: 'Illinois' },
    { abbr: 'IN', name: 'Indiana' },
    { abbr: 'IA', name: 'Iowa' },
    { abbr: 'KS', name: 'Kansas' },
    { abbr: 'KY', name: 'Kentucky' },
    { abbr: 'LA', name: 'Louisiana' },
    { abbr: 'ME', name: 'Maine' },
    { abbr: 'MD', name: 'Maryland' },
    { abbr: 'MA', name: 'Massachusetts' },
    { abbr: 'MI', name: 'Michigan' },
    { abbr: 'MN', name: 'Minnesota' },
    { abbr: 'MS', name: 'Mississippi' },
    { abbr: 'MO', name: 'Missouri' },
    { abbr: 'MT', name: 'Montana' },
    { abbr: 'NE', name: 'Nebraska' },
    { abbr: 'NV', name: 'Nevada' },
    { abbr: 'NH', name: 'New Hampshire' },
    { abbr: 'NJ', name: 'New Jersey' },
    { abbr: 'NM', name: 'New Mexico' },
    { abbr: 'NY', name: 'New York' },
    { abbr: 'NC', name: 'North Carolina' },
    { abbr: 'ND', name: 'North Dakota' },
    { abbr: 'OH', name: 'Ohio' },
    { abbr: 'OK', name: 'Oklahoma' },
    { abbr: 'OR', name: 'Oregon' },
    { abbr: 'PA', name: 'Pennsylvania' },
    { abbr: 'RI', name: 'Rhode Island' },
    { abbr: 'SC', name: 'South Carolina' },
    { abbr: 'SD', name: 'South Dakota' },
    { abbr: 'TN', name: 'Tennessee' },
    { abbr: 'TX', name: 'Texas' },
    { abbr: 'UT', name: 'Utah' },
    { abbr: 'VT', name: 'Vermont' },
    { abbr: 'VA', name: 'Virginia' },
    { abbr: 'WA', name: 'Washington' },
    { abbr: 'WV', name: 'West Virginia' },
    { abbr: 'WI', name: 'Wisconsin' },
    { abbr: 'WY', name: 'Wyoming' },
    { abbr: 'DC', name: 'Washington D.C.' }
  ];

  // ── Styles ────────────────────────────────────────────────────────────────────

  function injectStyles() {
    if (document.getElementById('noa-state-filter-styles')) return;
    var css = [
      '@keyframes noa-fade-in {',
      '  from { opacity:0; transform:translateY(-4px); }',
      '  to   { opacity:1; transform:translateY(0); }',
      '}',

      '#noa-state-filter {',
      '  background:#fff;',
      '  border:1.5px solid #d0dae8;',
      '  border-radius:8px;',
      '  overflow:hidden;',
      '  margin-bottom:22px;',
      '  box-shadow:0 2px 8px rgba(26,58,107,.07);',
      '  animation:noa-fade-in 0.3s ease both;',
      '}',

      '#noa-filter-row {',
      '  display:flex;',
      '  align-items:stretch;',
      '  height:48px;',
      '}',

      '#noa-filter-label {',
      '  display:flex;',
      '  align-items:center;',
      '  gap:7px;',
      '  padding:0 16px;',
      '  height:48px;',
      '  box-sizing:border-box;',
      '  color:#1a3a6b;',
      '  font-size:12px;',
      '  font-weight:700;',
      '  letter-spacing:0.08em;',
      '  text-transform:uppercase;',
      '  white-space:nowrap;',
      '  flex-shrink:0;',
      '  background:#f0f4fa;',
      '  border-right:1.5px solid #d0dae8;',
      '}',

      '#noa-select-wrap {',
      '  position:relative;',
      '  flex:1 1 0%;',
      '  min-width:0;',
      '  display:flex;',
      '  align-items:center;',
      '  height:48px;',
      '  box-sizing:border-box;',
      '  background:#fff;',
      '  cursor:pointer;',
      '  transition:background .15s;',
      '}',
      '#noa-select-wrap:hover { background:#f4f7fb; }',

      '#noa-select-display {',
      '  flex:1 1 0%;',
      '  min-width:0;',
      '  padding:0 40px 0 16px;',
      '  font-size:14px;',
      '  font-weight:500;',
      '  color:#1a3a6b;',
      '  white-space:nowrap;',
      '  overflow:hidden;',
      '  text-overflow:ellipsis;',
      '  pointer-events:none;',
      '  line-height:1.5;',
      '}',
      '#noa-select-display.noa-placeholder { color:#999; font-weight:400; }',
      '#noa-select-display.noa-has-value   { font-weight:700; font-size:15px; }',

      '#noa-select-arrow {',
      '  position:absolute;',
      '  right:14px;',
      '  top:50%;',
      '  transform:translateY(-50%);',
      '  pointer-events:none;',
      '  display:flex;',
      '  align-items:center;',
      '}',

      '#noa-state-select {',
      '  position:absolute;',
      '  inset:0;',
      '  width:100%;',
      '  height:100%;',
      '  opacity:0;',
      '  cursor:pointer;',
      '  border:none;',
      '  background:transparent;',
      '  font-size:14px;',
      '}',

      '#noa-filter-right {',
      '  display:flex;',
      '  align-items:center;',
      '  gap:8px;',
      '  padding:0 14px;',
      '  flex-shrink:0;',
      '  height:48px;',
      '  box-sizing:border-box;',
      '  white-space:nowrap;',
      '}',
      '#noa-filter-right.noa-active { border-left:1.5px solid #d0dae8; }',

      '#noa-filter-clear {',
      '  display:none;',
      '  align-items:center;',
      '  gap:4px;',
      '  background:none;',
      '  border:1.5px solid #c8c8c8;',
      '  color:#777;',
      '  font-size:12px;',
      '  font-weight:600;',
      '  cursor:pointer;',
      '  padding:4px 11px;',
      '  border-radius:50px;',
      '  line-height:1;',
      '  white-space:nowrap;',
      '  flex-shrink:0;',
      '  transition:border-color .15s, color .15s, background .15s;',
      '}',
      '#noa-filter-clear:hover { border-color:#c0392b; color:#c0392b; background:#fff5f5; }',
      '#noa-filter-clear.noa-visible { display:flex; }',

      '#noa-no-results {',
      '  display:none;',
      '  padding:32px 20px;',
      '  text-align:center;',
      '  color:#555;',
      '  font-size:15px;',
      '}',
      '#noa-no-results strong { display:block; font-size:16px; color:#1a3a6b; margin-bottom:5px; }',

      '.grid__item[data-state-tags] { transition:opacity 0.18s ease; }',
      '.noa-item-hidden { display:none !important; }',

      /* Mobile: CSS grid layout */
      '@media (max-width:600px) {',
      '  #noa-filter-row {',
      '    display:grid;',
      '    grid-template-columns:1fr auto;',
      '    grid-template-rows:auto auto;',
      '    height:auto;',
      '  }',
      '  #noa-filter-label {',
      '    grid-column:1/-1;',
      '    height:auto;',
      '    padding:9px 14px;',
      '    border-right:none;',
      '    border-bottom:1.5px solid #d0dae8;',
      '    box-sizing:border-box;',
      '  }',
      '  #noa-select-wrap {',
      '    grid-column:1;',
      '    grid-row:2;',
      '    height:44px;',
      '    box-sizing:border-box;',
      '  }',
      '  #noa-filter-right {',
      '    grid-column:2;',
      '    grid-row:2;',
      '    height:44px;',
      '    border-left:1.5px solid #d0dae8;',
      '    padding:0 12px;',
      '    flex-shrink:0;',
      '  }',
      '  #noa-filter-right:not(.noa-active) { display:none; }',
      '  #noa-filter-clear { font-size:13px; padding:4px 10px; }',
      '}',
    ].join('\n');

    var style = document.createElement('style');
    style.id = 'noa-state-filter-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  // ── Build HTML ────────────────────────────────────────────────────────────────

  function buildFilterHTML(activeState) {
    var mapSVG = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3V6z"/><line x1="9" y1="3" x2="9" y2="18"/><line x1="15" y1="6" x2="15" y2="21"/></svg>';
    var arrowSVG = '<svg width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M1 1L6 7L11 1" stroke="#1a3a6b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var xSVG = '<svg width="9" height="9" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><path d="M6 4.586L10.293.293a1 1 0 111.414 1.414L7.414 6l4.293 4.293a1 1 0 01-1.414 1.414L6 7.414l-4.293 4.293a1 1 0 01-1.414-1.414L4.586 6 .293 1.707A1 1 0 011.707.293L6 4.586z"/></svg>';

    var options = '<option value="">Select your state</option>';
    ALL_STATES.forEach(function(s) {
      var sel = s.abbr === (activeState || '').toUpperCase() ? ' selected' : '';
      options += '<option value="' + s.abbr + '"' + sel + '>' + s.name + ' (' + s.abbr + ')</option>';
    });

    var stateObj = activeState ? ALL_STATES.filter(function(s){ return s.abbr === activeState.toUpperCase(); })[0] : null;
    var displayText = stateObj ? stateObj.name + ' (' + stateObj.abbr + ')' : 'Select your state';
    var hasValue = !!activeState;

    return [
      '<div id="noa-state-filter" role="search" aria-label="Filter products by state">',
        '<div id="noa-filter-row">',
          '<div id="noa-filter-label">' + mapSVG + 'Shop by state</div>',
          '<div id="noa-select-wrap">',
            '<div id="noa-select-display" class="' + (hasValue ? 'noa-has-value' : 'noa-placeholder') + '">' + displayText + '</div>',
            '<span id="noa-select-arrow">' + arrowSVG + '</span>',
            '<select id="noa-state-select" aria-label="Select your state">' + options + '</select>',
          '</div>',
          '<div id="noa-filter-right"' + (hasValue ? ' class="noa-active"' : '') + '>',
            '<button id="noa-filter-clear" type="button" class="' + (hasValue ? 'noa-visible' : '') + '" aria-label="Clear state filter">' + xSVG + 'Clear</button>',
          '</div>',
        '</div>',
      '</div>',
    ].join('');
  }

  // ── Tag parsing ───────────────────────────────────────────────────────────────

  function parseTags(tagsStr) {
    var inc = [], exc = [], allStates = false;
    if (!tagsStr) return { include: inc, exclude: exc, allStates: false };
    tagsStr.split(',').forEach(function(tag) {
      tag = tag.trim().toUpperCase();
      if (tag === 'ALL-STATES') { allStates = true; return; }
      var m1 = tag.match(/^STATE-([A-Z]{2})$/);
      var m2 = tag.match(/^EXCLUDE-([A-Z]{2})$/);
      if (m1) inc.push(m1[1]);
      if (m2) exc.push(m2[1]);
    });
    return { include: inc, exclude: exc, allStates: allStates };
  }

  function productMatchesState(tagsStr, state) {
    if (!state) return true;
    var p = parseTags(tagsStr);
    var s = state.toUpperCase();

    // all-states tag: show unless excluded
    if (p.allStates) {
      return p.exclude.indexOf(s) === -1;
    }

    // Has include tags: only show for those states
    if (p.include.length > 0) {
      return p.include.indexOf(s) !== -1;
    }

    // Has exclude tags only: show unless excluded
    if (p.exclude.length > 0) {
      return p.exclude.indexOf(s) === -1;
    }

    // No state tags: universal — always show
    return true;
  }

  // ── Apply filter ──────────────────────────────────────────────────────────────

  function applyFilter(state) {
    var items = document.querySelectorAll('.grid-link__container .grid__item[data-state-tags]');
    var grid  = document.querySelector('.grid-link__container');
    var visible = 0;

    items.forEach(function(item) {
      var show = productMatchesState(item.getAttribute('data-state-tags'), state);
      item.classList.toggle('noa-item-hidden', !show);
      if (show) visible++;
    });

    // Toggle flexbox reflow — active when filter is on so items fill gaps
    if (grid) grid.classList.toggle('noa-filter-active', !!state);

    // Clear button
    var clearBtn = document.getElementById('noa-filter-clear');
    var rightEl  = document.getElementById('noa-filter-right');
    var selEl    = document.getElementById('noa-state-select');
    var display  = document.getElementById('noa-select-display');

    if (clearBtn) clearBtn.classList.toggle('noa-visible', !!state);
    if (rightEl)  rightEl.classList.toggle('noa-active', !!state);
    if (selEl)    selEl.classList.toggle('noa-has-value', !!state);

    if (display) {
      if (state) {
        var stateObj = ALL_STATES.filter(function(s){ return s.abbr === state.toUpperCase(); })[0];
        display.textContent = stateObj ? stateObj.name + ' (' + stateObj.abbr + ')' : state;
        display.classList.remove('noa-placeholder');
        display.classList.add('noa-has-value');
      } else {
        display.textContent = 'Select your state';
        display.classList.add('noa-placeholder');
        display.classList.remove('noa-has-value');
      }
    }

    // No results message
    var noRes = document.getElementById('noa-no-results');
    if (noRes) noRes.style.display = (visible === 0 && state) ? 'block' : 'none';
  }

  // ── Persist ───────────────────────────────────────────────────────────────────

  function saveState(v)  { try { sessionStorage.setItem(STATE_KEY, v || ''); } catch(e) {} }
  function loadState()   { try { return sessionStorage.getItem(STATE_KEY) || ''; } catch(e) { return ''; } }

  // ── Init ──────────────────────────────────────────────────────────────────────

  function init() {
    var grid = document.querySelector('.grid-link__container');
    if (!grid) return;
    if (!window.location.pathname.match(/\/collections\//) && window.location.pathname !== '/' && window.location.pathname !== '') return;

    injectStyles();

    var savedState = loadState();

    // Inject filter UI
    var isHome = window.location.pathname === '/' || window.location.pathname === '';
    var homeMount = document.getElementById('noa-home-filter-mount');
    var insertTarget = (isHome && homeMount) ? homeMount : grid;

    var wrapper = document.createElement('div');
    wrapper.innerHTML = buildFilterHTML(savedState);
    insertTarget.parentNode.insertBefore(wrapper.firstChild, insertTarget);

    // No results message
    var noRes = document.createElement('div');
    noRes.id = 'noa-no-results';
    noRes.innerHTML = '<strong>No products found for this state.</strong>Call us at <a href="tel:18008646395" style="color:#1a3a6b;">1-800-864-6395</a> for assistance.';
    grid.appendChild(noRes);

    // Apply saved filter on load
    if (savedState) applyFilter(savedState);

    // Wire select
    var select  = document.getElementById('noa-state-select');
    var display = document.getElementById('noa-select-display');

    select.addEventListener('change', function() {
      var val = this.value;
      saveState(val);
      applyFilter(val);
    });

    // Wire clear
    var clearBtn = document.getElementById('noa-filter-clear');
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        select.value = '';
        saveState('');
        applyFilter('');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
